import { formatDateGregorian, formatDateTimeGregorian } from './modules/dateFilters.js'
import { stripProcessTitleSuffix } from './modules/titleFilters.js'


export default {
	install(Vue) {

		Vue.filter('formatDateGregorian', formatDateGregorian)

		Vue.filter('formatDateTimeGregorian', formatDateTimeGregorian)

		Vue.filter('stripProcessTitleSuffix', stripProcessTitleSuffix)

	},
}